<div class="tw-bg-yellowLight tw-p-4 md:tw-p-6 tw-rounded-md">
  <h2 class="tw-font-bold tw-text-2xl">Own a car, the smart way!</h2>
  <br>
  <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-3 md:tw-gap-4">
    <div class="tw-flex tw-items-center tw-gap-2 tw-bg-white tw-border-yellow tw-border tw-rounded-md tw-py-2 tw-px-3">
      <img style="width: 32px;" src="assets/illustrations/no-hassle/downpayment.svg" alt="Zero Down Payment">
      <p class="tw-text-sm">Zero Down Payment</p>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2 tw-bg-white tw-border-yellow tw-border tw-rounded-md tw-py-2 tw-px-3">
      <img style="width: 32px;" src="assets/illustrations/no-hassle/HighQCars.svg" alt="White Number Plate">
      <p class="tw-text-sm">White Number Plate</p>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2 tw-bg-white tw-border-yellow tw-border tw-rounded-md tw-py-2 tw-px-3">
      <img style="width: 32px;" src="assets/illustrations/no-hassle/service.svg" alt="Free Service & Maintenance">
      <p class="tw-text-sm">Free Service & Maintenance</p>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2 tw-bg-white tw-border-yellow tw-border tw-rounded-md tw-py-2 tw-px-3">
      <img style="width: 32px;" src="assets/illustrations/no-hassle/RSA.svg" alt="24x7 Road Side Assistance">
      <p class="tw-text-sm">24x7 Road Side Assistance</p>
    </div>
  </div>
</div>